import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Form from "../../common/forms/Form";
import FormInput from "../../common/forms/FormInput";
import RequestCompleteNotice from "../../common/settings-modal/RequestCompleteNotice";
import NotificationModal from "../../common/settings-modal/NotificationModal";

import { RequestState } from "../../utils/RequestState";

import styles from "./ReportModal.module.scss";

type Props = {
  modalHandler: () => void;
  handleSubmit: () => void;
  chatPartners: Array<{ id: string; name: string }>;
  target?: { id: string; name: string };
  setTarget: (value?: { id: string; name: string }) => void;
  setMessage: (value: string) => void;
  requestState: RequestState;
  error: boolean;
};

const ReportModal: React.FC<Props> = ({
  modalHandler,
  handleSubmit,
  chatPartners,
  target,
  setTarget,
  setMessage,
  requestState,
  error,
}) => {
  const modalColor = () => {
    switch (requestState) {
      case RequestState.Failed:
        return "#ff4500";
      case RequestState.Doing:
        return "#f79b00";
      default:
        return "";
    }
  };

  const modalMessage = () => {
    switch (requestState) {
      case RequestState.Failed:
        return "送信に失敗しました";
      case RequestState.Doing:
        return "送信中・・・";
      default:
        return "";
    }
  };

  const genTargetOptions = (partners: Array<{ id: string; name: string }>) => {
    const options: Array<[string, string]> = [["", "選択してください"]];
    partners.forEach((partner) => options.push([partner.id, partner.name]));
    return options;
  };

  return (
    <div className={styles["f-report__wrapper"]}>
      {requestState === RequestState.Success ? (
        <RequestCompleteNotice
          handler={() => {
            history.back();
          }}
          title="報告完了"
          text={`ご報告いただきありがとうございます。\nご確認させていただきますので、今しばらくお待ちください。`}
          sub_text={`※数日お時間を頂戴する場合がございます。\n予めご了承くださいますようお願いいたします。`}
          displayImage={false}
        />
      ) : (
        <div className={styles["f-report"]}>
          <div className={styles["f-report__header"]}>SELeCTに報告する</div>
          <FontAwesomeIcon icon={["fas", "times"]} onClick={modalHandler} />
          <Form
            handler={() => handleSubmit()}
            className={styles["f-report__form"]}
            button_text="送信"
            button_id="report"
            button_class={styles["f-report__btn"]}
          >
            <FormInput
              handler={(value) => {
                if (typeof value === "string") {
                  const target = chatPartners.find(
                    (partner) => partner.id === value
                  );
                  target ? setTarget(target) : setTarget(undefined);
                }
              }}
              label_class={styles["f-report__form-label"]}
              select_class={styles["f-report__form-input"]}
              holder_class={`${styles["f-report__form-input"]} ${styles["placeholder"]}`}
              type="select"
              label="対象者"
              name="target"
              options={genTargetOptions(chatPartners)}
              initial_value={target?.id}
            />
            <FormInput
              handler={(value) => {
                if (typeof value === "string") {
                  setMessage(value);
                }
              }}
              label_class={styles["f-report__form-label"]}
              style_class={styles["f-report__form-input"]}
              type="textarea"
              label="報告内容"
              name="message"
              rows={8}
            />
            {error ? (
              <div className={styles["f-report__error"]}>
                必須項目が入力されていません
              </div>
            ) : null}
          </Form>
        </div>
      )}
      {requestState !== RequestState.Waiting ? (
        <NotificationModal
          color={modalColor()}
          icon_class={
            requestState === RequestState.Failed
              ? ["fal", "times-circle"]
              : undefined
          }
          message={modalMessage()}
          type="contact"
        />
      ) : null}
    </div>
  );
};

export default ReportModal;
